import { freedomTarget, netWorth, passiveIncome, totalExpenses } from '../game/finance'
import { useGame } from '../store/gameStore'
import type { GameState } from '../game/types'
import { money } from '../util/format'

export function WinScreen({ g }: { g: GameState }) {
  const { quit } = useGame()
  const winner = g.winner !== null ? g.players[g.winner] : null
  const ranked = g.players
    .slice()
    .sort((a, b) => {
      if (a.id === g.winner) return -1
      if (b.id === g.winner) return 1
      if (a.bankrupt !== b.bankrupt) return a.bankrupt ? 1 : -1
      return netWorth(g, b) - netWorth(g, a)
    })

  return (
    <div className="modal-scrim">
      <div className="modal win-modal tone-good">
        <header className="modal-head">
          <span className="modal-emoji win-emoji">{winner ? winner.character.emoji : '🤝'}</span>
          <span className="modal-kicker">
            {winner?.freedomRound ? `หลุดพ้นวงจรหนูในรอบที่ ${winner.freedomRound}` : 'จบเกม'}
          </span>
          <h2>{winner ? `${winner.name} ชนะ!` : 'เสมอ'}</h2>
        </header>

        {winner && (
          <p className="modal-text">
            {winner.freedomRound
              ? `Passive Income ${money(passiveIncome(g, winner))} ต่อเดือน แซงรายจ่ายรวม ${money(totalExpenses(winner))} — ไม่ต้องทำงานเพื่อเงินอีกแล้ว`
              : 'คู่แข่งล้มละลายหมด — ผู้รอดคนสุดท้ายคือผู้ชนะ'}
          </p>
        )}

        <div className="standings">
          {ranked.map((p, i) => (
            <div key={p.id} className={`stand${p.id === g.winner ? ' win' : ''}${p.bankrupt ? ' out' : ''}`}>
              <span className="stand-rank">{i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}</span>
              <span className="stand-ava" style={{ background: p.character.color }}>
                {p.character.emoji}
              </span>
              <span className="stand-id">
                <b>{p.name}</b>
                <em className="faint tiny">
                  {p.profession.emoji} {p.profession.name}
                  {p.bankrupt ? ' · ล้มละลาย' : ''}
                </em>
              </span>
              <span className="stand-nums">
                <em className="faint tiny">มูลค่าสุทธิ</em>
                <b className="num">{money(netWorth(g, p))}</b>
              </span>
              <span className="stand-nums">
                <em className="faint tiny">Passive / เป้า</em>
                <b className="num">
                  {money(passiveIncome(g, p))}
                  <span className="faint"> / {money(freedomTarget(g, p))}</span>
                </b>
              </span>
              <span className="stand-nums">
                <em className="faint tiny">ค่าเช่าที่เก็บได้</em>
                <b className="num">{money(p.stats.rentEarned)}</b>
              </span>
            </div>
          ))}
        </div>

        <div className="modal-actions">
          <button className="btn btn-primary btn-lg" onClick={quit}>
            🔄 เล่นเกมใหม่
          </button>
        </div>
      </div>
    </div>
  )
}
